import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import feedback from '../../../assets/img/notify.jpg';
import { chatListBuyer, chatSearchSeller, chatTaskListBuyer, readAllNotification } from '../../../Redux/Chats/action';
import { viewUserProfile } from '../../../Redux/User/action';
import ZIM from "zego-zim-web";
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import { IMAGE_URL } from '../../../api';
import OneSignalReact from 'react-onesignal';
// import { ZegoUIKitPrebuilt } from '../../ChatCall/zego-uikit-prebuilt.js';
import InfiniteScroll from 'react-infinite-scroll-component';
import { IoCall } from 'react-icons/io5';



const ChatsSeller = () => {

    const params = useParams()
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [status, setStatus] = useState(1);
    const [user, setUser] = useState({});
    const [totalPageNumber, setTotalPageNumber] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const __search = (e) => {
        chatListBuyer(e?.target?.value)((response) => {
            if (response?.status && response?.data) {
                setData(response?.data?.data)
            }
        });
    }
    const statusChat = (e) => {
        if (e.target.checked) {
            setStatus(e.target.value)
        }
    }
    useEffect(() => {
        viewUserProfile()((response) => {
            if (response && response.status) {
                setUser(response?.data?.data[0])
            }
        });
        // let formData = new FormData();
        // chatSearchSeller({ formData })((response) => {
        //     if (response && response.status) {
        //         setData(response?.data?.data)
        //     }
        // });

        chatTaskListBuyer(params?.id, page, 12)((response) => {
            if (response && response.status) {
                if ((data.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setData(response?.data?.data)
                setTotalPageNumber(response?.data?.total_pages)
            }
        });
    }, []);
    const handleClickUserTask = (task) => {
        readAllNotification(task?.id, true)((response) => {

        })
        navigate('/chat/', { state: { collection: task?.users_list[0]?.email + task?.task_details?.id + task?.task_details?.user_data[0]?.email + task?.task_details?.id, reciever: task?.task_details?.user_data[0], task_detail: task?.task_details?.id, task_detail_id: task?.id } })

    }
    useEffect(() => {
        OneSignalReact.on('notificationDisplay', function (event) {
            const notification_data = event.data.status
            if (notification_data === "online message" || notification_data === "Task Completed") {
                chatTaskListBuyer(params?.id, page, 12)((response) => {
                    if (response && response.status) {
                        setData(response?.data?.data)
                    }
                });
            }
        });
    }, [])

    const paginate = () => {
        chatTaskListBuyer(params?.id, page, 12)((response) => {
            if (response.status) {
                if ((data.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setData(data.concat(response?.data?.data))
            }
            else {
                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Chats </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Chats</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <Form >
                                {['radio'].map((type) => (
                                    <div key={`inline-${type}`} className="text-center mb-5">
                                        <Form.Check
                                            inline
                                            label="Online"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-1`}
                                            className='online'
                                            onChange={(e) => statusChat(e)}
                                            value="1"
                                            defaultChecked
                                        />
                                        <Form.Check
                                            inline
                                            label="Offline"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-2`}
                                            className='offline'
                                            onChange={(e) => statusChat(e)}
                                            value="2"
                                        />
                                        <Form.Check
                                            inline
                                            label="Away"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-3`}
                                            className='away'
                                            onChange={(e) => statusChat(e)}
                                            value="3"
                                        />

                                    </div>
                                ))}
                            </Form>
                        </div>
                        <div className='col-lg-12'>
                            <form className="search-form d-flex align-items-center justify-content-center" >
                                <input type="text" name="query" placeholder="Search seller's name" title="Search" onChange={(e) => __search(e)} className='w-50' />
                                <button type="submit" title="Search">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon searchlist-icon' fill="#fff" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="chats section-bg p-0">
                <InfiniteScroll
                    dataLength={data.length}
                    next={paginate}
                    hasMore={hasMore}
                    loader={<p style={{ textAlign: 'center' }}>
                        <b>Loading...</b>
                    </p>}
                    endMessage={
                        <p style={{ textAlign: 'center' }}>
                            <b>Yay! You have seen it all</b>
                        </p>
                    }
                >
                    <div className="container">
                        <div className="row">
                            {data?.map((task, index) =>
                                <React.Fragment>
                                    <div className="col-lg-3">
                                        <div className='chats-sec'
                                            onClick={() => handleClickUserTask(task)}
                                        // to={'/chat/' + user?.user?.email + task?.task_details?.id + task?.users_list[0]?.email + task?.task_details?.id}
                                        >
                                            <div className="member d-flex align-items-start">
                                                {task?.unread_message_count > 0 ?
                                                    <div className='chat-notification-count'>
                                                        <i class="bi bi-chat-dots"><span className='rounded-circle rounded-chat-notification'>{task?.unread_message_count}</span></i>
                                                    </div>
                                                    :
                                                    <div className='chat-notification-count'>
                                                        <IoCall color='#37517e' fontSize={"18px"} />
                                                    </div>
                                                }
                                                <div className="pic"><img src={IMAGE_URL + task?.task_details?.user_data[0]?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                <div className="member-info">
                                                    <h4>{task?.task_details?.title}</h4>
                                                    <span style={{ color: "#1bbaed", fontWeight: "700", fontSize: "16px" }}>{task?.task_details?.user_data[0]?.username}</span>
                                                    {task?.bid_rate == "" ?
                                                        <>
                                                            <p className='bid_rate_chat'>Call Rate: {task?.call_rate}</p>
                                                            <p className='bid_rate_chat'>Chat Rate: {task?.chat_rate}</p>
                                                        </>

                                                        :
                                                        <>
                                                            <p className='bid_rate_chat'>Bid Rate: {task?.bid_rate}</p>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </InfiniteScroll>
            </section>

            <Footer />
        </React.Fragment>
    )
}

export default ChatsSeller;